import styled from 'styled-components'
import theme from '../../config/theme'
import {Link} from '@/src/shared/ui/link'

export const PopoverContent = styled.div`
    width: 100%;
    max-width: ${theme.sizes.container}px;
    overflow: 'auto'
`

export const PopoverContainer = styled.div`
    position: fixed;
    left: 0;
    width: 100%;
    
    .ant-popover {
        left: 0 !important;
        width: 100%;
    }
    
    .ant-popover-inner-content {
        justify-content: center;
        display: flex;
    }
`

export const SectionButton = styled(Link)`
    align-items: center !important;
    font-size: 1.25rem;
    font-weight: 450;
    cursor: pointer;
    gap: 12px;
    width: max-content;

    display: flex;
    align-items: flex-end;

    border-radius: 10px;

    padding: 16px 20px;
    
    img {
        object-fit: cover;
        max-width: 100%;
        max-height: 100%;
        box-sizing: unset;
        border: solid 1px transparent;

        * {
            box-sizing: border-box;
        }
    }

    &[data-active='true'] {
        background: ${theme.colors.primary};
        color: black;
    }
}
`

export const SubSectionButton = styled(SectionButton)`
    border-left: solid 4px transparent;
    padding-left: 16px;
    
    &[data-active='true'], &:hover {
        background: ${theme.colors.grayTransparent};
        border-left: solid 4px ${theme.colors.primary};
        //color: ${theme.colors.primary};
    }

    &:hover {
        color: ${theme.colors.primary};
    }
`

export const SectionImage = styled.div`
    padding: 4px;
    width: 48px;
    height: 48px;
    transition: 0.5s ease all;
    box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px;
    border-radius: 10px;
    background: white;
  
    img {
      object-fit: contain;
    }
`

export const Content = styled.div`
`

export const CatalogComponent = styled.div`
  max-height: 100%;
  
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
`

export const CatalogSection = styled.div`
  width: calc(100% / 3);
  padding-bottom: 8px;

  .ant-menu-item,
  .ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title {
    height: unset;
    line-height: 1.5;
    padding-left: 4px;
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 14px;
    
    span {
      coror: gray;
    }
  }

  .ant-menu {
    border: unset !important;
    border-right: unset !important;
    border-left: unset !important;
  }
`

export const CatalogSectionName = styled(Link)`
    font-size: 1.125rem;
    font-weight: 450;
`

export const CatalogSectionChild = styled.div``

export const Col = styled.div`
  overflow: auto;
  padding-right: 33px;
  flex: 0 0 auto;
  
  &:last-child {
    padding-right: unset;
    flex: 0 1 auto;
  }
`

export const ColFlex = styled.div`
    max-height: calc(-150px + 100vh);
`

export const CategoryCol = styled.div`
    border-right: solid 1px #E5E7EB;
`

export const CategoryFlex = styled.div`
    padding-right: 33px;
`

export const CategoryTitle = styled.div`
    font-size: 0.875rem;
    
    color: oklch(55.1% .027 264.364);
    text-transform: uppercase;
`


export const SectionGroup = styled.div``
export const SectionContainer = styled.div``

export const SectionGroupTitle = styled(CategoryTitle)``

export const SectionCollapse = styled.div`

    &,
    .ant-collapse,
    .ant-collapse-content {
        border: unset;
    }

    &.ant-collapse > .ant-collapse-item > .ant-collapse-header {
        //font-size: 1.25rem;
        font-weight: 450;
        cursor: pointer;
        gap: 12px;
        width: max-content;

        display: flex;
        align-items: center;

        line-height: 1;

        border-radius: 10px !important;

        padding: 16px 20px;

        border-left: solid 4px transparent;
        
        span {
            font-size: 1.25rem;
        }
        
        img {
            object-fit: cover;
            max-width: 100%;
            max-height: 100%;
            box-sizing: unset;
            border: solid 1px transparent;

            * {
                box-sizing: border-box;
            }
        }

        &[data-active='true'], &:hover {
            background: ${theme.colors.grayTransparent};
            border-left: solid 4px ${theme.colors.primary};
            color: black;
        }
    }

    &.ant-collapse > .ant-collapse-item.ant-collapse-item-active > .ant-collapse-header {
        background: ${theme.colors.grayTransparent};
        border-left: solid 4px ${theme.colors.primary};
        color: black;
    }
    
    &.ant-collapse .ant-collapse .ant-collapse-item > .ant-collapse-header {
        padding: unset !important;

        &:hover {
            background: transparent;
            border-left: solid 4px transparent;
        }
    }
    
    &.ant-collapse .ant-collapse-item {
        border-bottom: unset;
    }
    
    &.ant-collapse .ant-collapse .ant-collapse-item.ant-collapse-item-active > .ant-collapse-header {
        background: transparent;
        border-left: solid 4px transparent;
    }
    
    &.ant-collapse .ant-collapse {
        margin-top: 16px;
        padding-left: 16px;
        border-left: solid 2px ${theme.colors.borderColor};
        border-radius: unset;
    }

    & .ant-collapse-content {
        .ant-collapse-content-box {
            padding-left: 16px;
            padding-top: 0;
        }
    }
    
    ${SectionButton} {
        align-items: center;
    }
`

export const ExpandIcon = styled.svg`
  transition: transform 0.3s ease-in-out;
`

export const SectionCollapseLabel = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`